import { render, staticRenderFns } from "./NewsBoardCreate.vue?vue&type=template&id=169d909a&"
import script from "./NewsBoardCreate.vue?vue&type=script&lang=ts&"
export * from "./NewsBoardCreate.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoardCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports